/**
 * Dokumente am Partner: Kategorien.
 *
 * Bewusst kurze Liste - sie steuert nur die Anzeige und den Filter, keine
 * Fachlogik. Was nirgends hineinpasst, ist "Sonstiges".
 */
export const PARTNER_ATTACHMENT_CATEGORIES = [
    'crefo',
    'power_of_attorney',
    'contract',
    'other',
];
export const PARTNER_ATTACHMENT_CATEGORY_LABELS = {
    crefo: 'Crefo-Auskunft',
    power_of_attorney: 'Vollmacht',
    contract: 'Vertrag/Vereinbarung',
    other: 'Sonstiges',
};
//# sourceMappingURL=partner-attachments.js.map